/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Steps_TitleInputs */

const en_directory_agents_steps_title = /** @type {(inputs: Directory_Agents_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happens next`)
};

const zh_directory_agents_steps_title = /** @type {(inputs: Directory_Agents_Steps_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下来会发生什么`)
};

/**
* | output |
* | --- |
* | "What happens next" |
*
* @param {Directory_Agents_Steps_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_steps_title = /** @type {((inputs?: Directory_Agents_Steps_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Steps_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_steps_title(inputs)
	return zh_directory_agents_steps_title(inputs)
});
export { directory_agents_steps_title as "directory.agents.steps_title" }